import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bf59d06"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-flow", "data-direction", "data-gap"]

import { computed } from "vue";
/** map nice human align names to css flex align names */
interface Props {
  /** flex display (whether container takes up full width) */
  flow?: "inline" | "block";
  /** horizontal or vertical */
  direction?: "row" | "col";
  /** spacing between items */
  gap?: "none" | "tiny" | "small" | "medium" | "big";
  /** horizontal alignment */
  hAlign?: "left" | "center" | "right" | "stretch";
  /** vertical alignment */
  vAlign?: "top" | "center" | "bottom" | "stretch";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFlex',
  props: {
    flow: { default: "block" },
    direction: { default: "row" },
    gap: { default: "medium" },
    hAlign: { default: "center" },
    vAlign: { default: "center" }
  },
  setup(__props: any) {

const props = __props as { flow: "inline" | "block", direction: "row" | "col", gap: "none" | "tiny" | "small" | "medium" | "big", hAlign: "left" | "center" | "right" | "stretch", vAlign: "top" | "center" | "bottom" | "stretch" }

const alignMap = {
  left: "flex-start",
  top: "flex-start",
  center: "center",
  right: "flex-end",
  bottom: "flex-end",
  stretch: "stretch",
};



/** css flex props */
const justifyContent = computed(() =>
  props.direction === "col" ? alignMap[props.vAlign] : alignMap[props.hAlign]
);
const alignItems = computed(() =>
  props.direction === "col" ? alignMap[props.hAlign] : alignMap[props.vAlign]
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex",
    "data-flow": __props.flow,
    "data-direction": __props.direction,
    "data-gap": __props.gap,
    style: _normalizeStyle({ justifyContent: _unref(justifyContent), alignItems: _unref(alignItems) })
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 12, _hoisted_1))
}
}

})